import type { SugarmateError } from "@tandemdiabetes/sugarmate-api-react-client"
import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { useMemo } from "react"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
  status?: SugarmateError["status"];
  code?: SugarmateError["code"];
}

const polyglotPrefix = "toasts.send_email_confirmation_code_error."

export function SendEmailConfirmationCodeErrorToast(props: Props) {
  const {
    id,
    code = null,
    status: responseStatus,
  } = props

  const polyglot = usePolyglot()
  const body = useMemo(
    () => {
      switch (code) {
        case 1013: // invalid email (should have status 422)
          return polyglot.t(`${polyglotPrefix}invalid_email_body`)
        default:
          // rate limited
          if (responseStatus === 429) {
            return polyglot.t(`${polyglotPrefix}rate_limited_body`)
          }

          return polyglot.t("error_messaging.generic_error")
      }
    },
    [
      code,
      responseStatus,
      polyglot,
    ],
  )

  return (
    <Toast
      stylePreset="error"
      body={body}
      id={id}
    />
  )
}
